/**
 * Curated issuing banks for card / linked-bank pickers (Brandfetch via domain).
 */
export const PAYMENT_BANKS = [
  { name: 'HDFC Bank', domain: 'hdfcbank.com' },
  { name: 'ICICI Bank', domain: 'icicibank.com' },
  { name: 'State Bank of India', domain: 'sbi.co.in' },
  { name: 'Axis Bank', domain: 'axisbank.com' },
  { name: 'Kotak Mahindra Bank', domain: 'kotak.com' },
  { name: 'IndusInd Bank', domain: 'indusind.com' },
  { name: 'Punjab National Bank', domain: 'pnbindia.in' },
  { name: 'Bank of Baroda', domain: 'bankofbaroda.in' },
  { name: 'Canara Bank', domain: 'canarabank.com' },
  { name: 'Union Bank of India', domain: 'unionbankofindia.co.in' },
  { name: 'IDFC FIRST Bank', domain: 'idfcfirstbank.com' },
  { name: 'Yes Bank', domain: 'yesbank.in' },
  { name: 'Federal Bank', domain: 'federalbank.co.in' },
  { name: 'RBL Bank', domain: 'rblbank.com' },
  { name: 'HSBC', domain: 'hsbc.com' },
  { name: 'Citibank', domain: 'citi.com' },
  { name: 'Standard Chartered', domain: 'sc.com' },
  { name: 'Chase', domain: 'chase.com' },
  { name: 'Bank of America', domain: 'bankofamerica.com' },
  { name: 'Wells Fargo', domain: 'wellsfargo.com' },
  { name: 'Capital One', domain: 'capitalone.com' },
  { name: 'Barclays', domain: 'barclays.com' },
  { name: 'Deutsche Bank', domain: 'db.com' }
];

export const PAYMENT_BANK_OTHER = '__other__';
